import createRoute    from '@widesk-ui/tools/createRoute';
import ProjectTemplateModel from '@models/map/ProjectTemplateModel';

export default createRoute.table('/project_templates', 'map', 'ProjectTemplateTable', ProjectTemplateModel.localize('plural'));